import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import ReactDOM from "react-dom/client";
import ReactModal from "react-modal";
import {QueryClient, QueryClientProvider} from "react-query";
import {BrowserRouter} from "react-router-dom";

import Core from "liberty-core";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function prepareMockServiceWorker() {
  if (process.env.REACT_APP_MOCK_ENABLED === "true") {
    return import("liberty-core/mocks/browser").then(({worker}) => {
      return worker.start({onUnhandledRequest: "bypass"});
    });
  }

  return Promise.resolve();
}

function initReact() {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
  ReactModal.setAppElement("#root");
}

Core.init({
  baseURL: process.env.REACT_APP_API_ROOT,
}).then(() => {
  prepareMockServiceWorker().then(initReact);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
